import handleSwitch from './handleSwitch';
/**
 * Returns a callback to initialize the component with the first entry
 * if no entry is already pre-selected.
 * @param {Element} component
 * @returns {Function} A callback function
 */
const handleInit = (component) => () => {
    const $inputs = $(component).find('.select input');
    $inputs.trigger('change');
    handleSwitch(component)();
};

export default handleInit;



// WEBPACK FOOTER //
// ./src/scripts/components/switcher/handleInit.js